import { GstChecks } from "../entities/CompanySettings";
import { SettingsRepository } from "../repositories/SettingsRepository";

/**
 * ZOUR-19 — runs the two on-demand GST checks.
 *
 * Report only. Neither check fixes anything: past documents are historical
 * records that a professional has to look at one by one, and a contact's GST
 * treatment is a judgement about who that party is. A settings page that
 * quietly rewrote either would be doing a CA's job badly.
 */
export class RunGstChecksUseCase {
  constructor(private readonly repository: SettingsRepository) {}

  execute(signal?: AbortSignal): Promise<GstChecks> {
    return this.repository.getGstChecks(signal);
  }
}
